import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './AlertOffersForm.jsx'

export default createSubmit(name)